import type { ChatMessage } from '@domain/chat';
import { logError } from '@/lib/logger';
import type { StreamMessage } from '@/hooks/useChatStream';
import type { ApiResult } from './flowTypes';

export const MAX_CARDS = 3;
export const AUTOSAVE_DELAY = 5000;

function buildHeaders(): HeadersInit {
  const csrf =
    typeof document !== 'undefined'
      ? document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
      : '';

  return {
    'Content-Type': 'application/json',
    'X-CSRF-Token': csrf,
  };
}

export async function requestJson<T>(
  url: string,
  options: RequestInit = {},
): Promise<ApiResult<T>> {
  try {
    const response = await fetch(url, {
      credentials: 'same-origin',
      headers: {
        ...buildHeaders(),
        ...(options.headers || {}),
      },
      ...options,
    });

    const data = await response.json();
    if (!response.ok) {
      return { ok: false, data };
    }

    return { ok: true, data };
  } catch (error) {
    logError('Journal flow request failed', error);
    return { ok: false };
  }
}

export function resolveChatId(value: unknown): number | null {
  if (typeof value === 'number') {
    return value;
  }
  if (typeof value === 'string') {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
}

export function mapStreamToChatMessages(messages: StreamMessage[]): ChatMessage[] {
  return messages.map((message) => ({
    id: message.id,
    role: message.role,
    content: message.content,
    createdAt: message.created_at,
    created_at: message.created_at,
  }));
}

export function formatCardResponseLabel(value?: string | null): string {
  switch (value) {
    case 'yes':
      return 'Mi risuona';
    case 'no':
      return 'Non oggi';
    case 'skip':
      return 'Saltata';
    default:
      return '—';
  }
}
